import React from 'react'
import Box from '@mui/material/Box'
import { Link } from 'react-router-dom'
import Brand from './Brand'

export default function PageBrand(): JSX.Element {
  return (
    <Box component="header" sx={{ width: '100%', py: 1, textAlign: 'center', flexShrink: 0 }}>
      <Link
        to="/"
        aria-label="RankTrivia home"
        style={{
          display: 'inline-flex',
          borderRadius: 16,
          textDecoration: 'none',
        }}
      >
        <Brand />
      </Link>
    </Box>
  )
}
